import { useEffect, useCallback } from 'react';

export default function useModalBackdropClose(isOpen, onClose) {
    const stableOnClose = useCallback(() => onClose(), [onClose]);

    useEffect(() => {
        if (!isOpen) return;

        function handleMouseDown(e) {
            const target = e.target;
            if (!target || target.nodeType !== 1) return;

            const isBackdrop =
                target.classList.contains('twds-fixed') &&
                target.classList.contains('twds-inset-0') &&
                target.classList.contains('twds-z-10') &&
                target.closest('[data-testid="portal"]');

            if (!isBackdrop) return;

            const allPortals = document.querySelectorAll('[data-testid="portal"]');
            const lastPortal = allPortals[allPortals.length - 1];
            if (target.closest('[data-testid="portal"]') === lastPortal) {
                stableOnClose();
            }
        }

        document.addEventListener('mousedown', handleMouseDown, true);
        return () => document.removeEventListener('mousedown', handleMouseDown, true);
    }, [isOpen, stableOnClose]);
}
